export enum QuoteType {
  Budget = 0,
  Internal = 1,
  Distributor = 2,
}

export enum GenerationType {
  Normal,
  Auto,
  Economic,
}

export enum HeightType {
  Ffl,
  Cu,
}

export enum BaySpacing {
  Economic,
  Even,
  Uneven,
}

export enum BeamDirection {
  Auto,
  Horizontal,
  Vertical,
}

export enum BuildingStandard {
  British,
  Ec3,
}

export enum LoadType {
  Office,
  Storage,
  Ind,
  Medium,
  Heavy,
  Special,
}

export enum DrawingType {
  Quote,
  Project,
}

export class BayDistance {
  Auto: boolean;
  Value: number;

  constructor(auto: boolean, value: number) {
    this.Auto = auto;
    this.Value = value;
  }
}

export class SessionData {
  Username: string;
  SessionId: string;
}

export class QuoteReference {
  Quote: string;
  Revision: string;
  Option: string;
}

export class GeneralData {
  QuoteReference = new QuoteReference();
  QuoteType: QuoteType;
  DistributorName: string;
  ContactName: string;
  Reference: string;
  Notes: string;
  QuoteDate: string;
  ExpectedInstallationDate: string;
  BuildingStandard: BuildingStandard;
  IsFireRated: boolean;
  CostTransport: boolean;
  AreaCode: number | any;
  CostInstallation: boolean;
  CostAncillaries: boolean;
  ExWorks: boolean;
  CostInstallationAsExtraOver: boolean;
}

export class GpData {
  TargetGp: number;
  FireRatingGp: number;
}

export class GridData {
  BaySpacing: BaySpacing;
  BeamDirection: BeamDirection;
  NotifyIfOtherBeamDirectionCheaper: boolean;
  YDim: number;
  XDim: number;
  XBays: number;
  YBays: number;
  XBayDistances: BayDistance[];
  YBayDistances: BayDistance[];
  IsMinBasePlateWidthMainAuto: boolean;
  IsMinBasePlateWidthEdgeAuto: boolean;
  MinBasePlateWidthMain: number;
  MinBasePlateWidthEdge: number;
}

export class DesignData {
  UcColumnsOnly: boolean;
  UseStubJoists: boolean;
  MaxFloorDepth: number;
  UseAngles: boolean;
  AdaptiveDesignProcedures: boolean;
  LimitStrutSections: boolean;
  StrutDistance: number;
}

export class DeckingData {
  IsDeckingRequired: boolean;
  DeckingCentres: number;
  DeckingSection: number | any;
}

export class CutoutData {
  Hash: string;
  X: number;
  Y: number;
  XDim: number;
  YDim: number;
}

export class TierData {
  Area: number;
  Depth: number;
  Height: number;
  LoadType: number | any;
  LiveLoad: number;
  DeadLoad: number;
  ServiceLoad: number;
  BeamDeflection: number;
  CalculatedBeamDeflections: number[];
  JoistDeflection: number;
  MinJoistThickness: number;
  CutoutData: CutoutData[];
}

export class TiersData {
  HeightType: HeightType;
  TierData: TierData[];
  CopyTierData: boolean;
  TierCount: number;
}

export class FloorData {
  GridData: GridData;
  DesignData: DesignData;
  DeckingData: DeckingData;
  TiersData: TiersData;
}

export class TransportData {
  TransportAuto: boolean;
  TransportLorries: number;
  AreaBandCost: number;
  LoadLorryCost: number;
  TransportTotal: number;
}

export class InstallationRate {
  installationRateType: InstallationRateType;
  days: number;
  area: number;
  netting: number;
}

export class InstallationRateType {
  description: string;
  costPerWeek: number;
}

export class InstallationData {
  IsInstallationAuto: Boolean;
  ClearBuildJob: Boolean;
  Area: number;
  TeamSize: string;
  NormalTeamCost: number;
  LargeTeamCost: number;
  Days: number;
  Cost: number;
  Netting: number;
  TotalCost: number;
  Stairs: number;
  Handrail: number;
  Locked: Boolean;
  SystemDisabledAutoInstallation: Boolean;
}

export class FireRatingData {
  CostFireRating: boolean;
  CostColumnCasings: boolean;
  ColumnCasingFinish: number; // enum?
  CostCeilings: boolean;
  CeilingGridSize: number;
  CostFascia: boolean;
  FasciaLengthAuto: boolean;
  FasciaLength: number;
  OverrideMinColumnThickness: boolean;
}

export class AncillaryArgument {
  Ancillary: number;
  IsExtraOver: boolean;
  Height: number;
  Length: number;
  Quantity: number;
  IsPlant: boolean;
  AutoCalculateHeight: boolean;
}

export class AncillaryData {
  CalcPlant: boolean;
  LongestJoistLength: number;
  LongestBeamLength: number;
  AncillaryArguments: AncillaryArgument[];
}

export class TransformData {
  ComponentId: string;
  TransformType: string;
  TierNumber: number;
  XPosition: number;
  YPosition: number;
  Index: number;
}

export class UserSettings {
  UserDefinedInstallation: boolean;
}

export class QuoteData {
  GeneralData: GeneralData;
  GpData: GpData;
  FloorData: FloorData;
  TransportData: TransportData;
  InstallationData: InstallationData;
  FireRatingData: FireRatingData;
  AncillaryData: AncillaryData;
  TransformData: TransformData[];
  UserSettings: UserSettings;
}
